// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"dbec4cbc","787":"01a9581a"}[chunkId] + ".chunk.js";
};